import $ from "jquery";
import Chart from 'chart.js';
import moment from 'moment';

const CHART_TYPE = 'line';

let UVChart = function (el, opts) {

    this.$el = $(el);
    this.opts = $.extend(true, {}, UVChart.defaults, this.$el.data(), opts || {});

    this.data = this.initData(window.uvData) || [];

    if (!this.initialised) {
        this.init();
    }

};

UVChart.prototype.init = function () {

    if (!this.chart) { // TODO interpolate the time data
        this.chart = new Chart(
            this.$el,
            {
                type: CHART_TYPE,
                data: this.data,
                options: this.opts
            }
        );
    }

    this.initialised = true;
};


UVChart.prototype.initData = function (data) {

    let modified = {
        datasets: [{
            data: []
        }],
        borderColor: '#7dafd6',
        borderWidth: 4,
        pointBackgroundColor: '#7dafd6',
        pointBorderWidth: 0,
        pointRadius: 0
    };

    data.forEach((record) => {
        modified.datasets[0].data.push(
            {
                x: moment(record.x),
                y: record.y
            }
        );
    });

    return modified;
};

UVChart.defaults = {
    responsive: true,
    legend: {
        display: false
    },
    scales: {
        yAxes: [{
            ticks: {
                max: 12,
                min: 0,
                display: true
            }
        }],
        xAxes: [{
            type: 'time',
            time: {
                unit: 'hour'
            },
            ticks: {
                source: 'auto',
                fontColor: '#61508c',
                fontStyle: 'bold',
                fontSize: 12
            }
        }]
    },
    layout: {
        padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }
    },
    animation: {
        duration: 0
    },
    hover: {
        animationDuration: 0
    },
    responsiveAnimationDuration: 0
};

UVChart.init = function (scope, opts) {
    $(scope || '[data-chart="uv"]').each((i, el) => {
        return new UVChart(el, opts);
    });
};

export default UVChart;